<template>
  <v-card flat class="my-duty-widget">
    <duty-card v-if="duty" :duty="duty"></duty-card>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import dateUtils from '@/common/dateUtils';
import DutyCard from '@/modules/myDuties/components/DutyCard.vue';
export default {
  name: 'NewsSelection',
  props: {
    config: {
      type: Object,
    },
  },
  components: {
    DutyCard,
  },

  computed: {
    duty() {
      console.debug('calculate duty');
      let todayMs = Date.now();
      let today = new Date();
      return this.duties.find((d) => {
        let date = new Date(Date.parse(d.day));
        console.debug('compare', d.day);
        console.debug('compare', new Date(date), new Date(today), date.getTime(), today);
        return dateUtils.isSameDate(today, date);
      });
    },
    ...mapState({
      duties: (state) => state.meinDienst.duties,
    }),
  },
};
</script>
